export default {
  de: {
    generic: {
      currency: "€"
    },
    form: {
      generic: {
        btn_save: "Speichern",
        btn_save_continue: "Speichern und fortfahren",
        btn_continue: "Fortfahren",
        btn_spinner: "Bitte warten...",
        btn_add: "Hinzufügen",
        btn_remove: "Eintrag entfernen",
        btn_form_invalid: "Bitte gib alle Daten an",
        btn_cancel: "Abbrechen",
        btn_yes: "Ja",
        btn_no: "Nein",
        required: "Pflichtfelder"
      },
      person: {
        block_name: "Deine persönlichen Daten",
        fld_sex: "Anrede",
        fld_sex_option_null: "Bitte auswählen",
        fld_sex_option_f: "Frau",
        fld_sex_option_m: "Herr",
        fld_firstname: "Vorname",
        fld_lastname: "Nachname",
        fld_birthdate: "Dein Geburtstag",
        all_valid: "Danke!",
        not_valid: "Bitte gib Deinen Namen ein, damit wir Dich richtig ansprechen können. Bitte gib Deinen Geburtsdatum an, damit wir feststellen, dass Du volljährig bzw. teilnahmeberechtigt bist.",
        block_is_incomplete: "Dein persönlichen Daten sind nicht vollständig ausgefüllt."
      },
      kids: {
        block_name: "Deine Kinder",
        kid_heading: "{{ cnt }}. Kind",
        btn_add_kid: "Weiteres Kind hinzufügen",
        btn_cancel: "Abbrechen",
        btn_remove_kid: "X",
        fld_firstname: "Vorname",
        fld_lastname: "Nachname",
        fld_sex: "Geschlecht",
        fld_sex_option_null: "Bitte auswählen",
        fld_sex_option_f: "weiblich",
        fld_sex_option_m: "männlich",
        fld_sex_option_unknown: "unbekannt",
        fld_birthdate: "Geburtstag/ -termin",
        all_valid: "Danke!",
        not_valid: "Bitte gib das Geburtsdatum oder den Geburtstermin Deines Kindes ein, damit wir Dich úber altersrelevante Kampagnen informieren können. Name und Geschlecht Deiner Kinder helfen uns bei personalifizierten Aktionen.",
        block_is_incomplete: "Bei deinen Kindern fehlen Daten."
      },
      address: {
        block_name: "Deine Adresse",
        fld_autocomplete: "Hausnummer, Strasse, Ort",
        lbl_autocomplete: "Addresssuche",
        autocomplete_error: "Keine Ergebnisse für: '{{ search_value }}'",
        address_update_error: "Ungültiges Adressformat!",
        fld_street: "Straße",
        fld_streetnumber: "Nummer",
        fld_co_line: "Adresszusatz",
        fld_zip: "PLZ",
        fld_locality: "Stadt",
        fld_country: "Land",
        fld_country_null: "Bitte auswählen",
        fld_country_de: "Deutschland",
        fld_country_ch: "Schweiz",
        fld_country_at: "Österreich",
        fld_country_other: "anderes",
        all_valid: "Danke!",
        not_valid: "Bitte gib Deinen gewöhnliche Aufenthaltsadresse ein, damit wir die für Dich relevantesten Kampagnen anzeigen können. Ausserdem brauchen wir Deine Adresse, um Dir Deinen Preis zuzustellen, wenn du bei einem Gewinnspiel gewinnst.",
        google_api_null: 'Wir konnten den "Google Maps Service" nicht erreichen. Vermutlich blockiert Dein Browser den Zugriff auf maps.googleapis.com. Deswegen können wir Deine Adresse nicht überprüfen. Dies kann zu Problemen bei der Benutzung von LetsFamily.de führen.',
        block_is_incomplete: "Deine Adresse ist nicht vollständig.",
        address_is_being_checked: "Wir überprüfen Deine Adresse...",
        address_is_valid: "Wir haben folgende Adresse gefunden:",
        address_is_valid_reject_title: "Haben wir eine falsche Adresse gefunden?",
        address_is_valid_reject_text: "Du hast folgende Adresse eingegeben:",
        address_not_valid: "Wir konnten Deine Adresse nicht finden!",
        address_not_valid_hint: "Bitte gib Deinen gewöhnliche Aufenthaltsadresse ein, damit wir die für Dich relevantesten Kampagnen anzeigen können. Ausserdem brauchen wir Deine Adresse, um Dir Deinen Preis zuzustellen, wenn du bei einem Gewinnspiel gewinnst.",
        address_fuzzy_hit: "Wir konnten Deine Eingabe nur ungefähr einer Adresse zuordnen!",
        address_fuzzy_hit_suggestion: "Diese Adresse haben wir gefunden:",
        address_fuzzy_hit_reject_title: "Haben wir eine falsche Adresse gefunden?",
        address_fuzzy_hit_reject_text: "Du hast folgende Adresse eingegeben:",
        btn_address_ok: "Diese Adresse verwenden",
        btn_use_my_address: "Die von mir eingegebene Adresse verwenden",
        btn_use_suggestion: "Die vorgeschlagene Adresse verwenden",
        btn_use_invalid_address: "Die von mir eingegebene Adresse trotzdem verwenden"
      },
      telephone: {
        block_name: "Deine Telefonnummer",
        btn_add_tnumber: "Weitere Telefonnummer hinzufügen",
        btn_remove_tnumber: "X",
        lbl_tnumber: "Neue Telefonnummer",
        fld_tnumber: "Telefonnummer",
        fld_placeholder_tnumber: "+49 123 456789",
        all_valid: "Danke!",
        not_valid: "Bitte gib Deine Telefonnummer ein, damit wir Dich im Gewinnfall verständigen können.",
        block_is_incomplete: "Deine Telefonnummer fehlt.",
        fld_prefix: "Vorwahl",
        lbl_prefix: "Vorwahl",
        fld_prefix_default: "Bitte auswählen",
        fld_prefix_de: "+49 (Deutschland",
        fld_prefix_at: "+43 (Österreich)",
        fld_prefix_ch: "+41 (Schweiz)",
        fld_prefix_fl: "+423 (Fürstentum Liechtenstein)",
        fld_prefix_other: "Andere",
      },
      birthdate: {
        label_person: "Dein Geburtstag*",
        label_kid: "Geburtstag / Geburtstermin*",
        day__person: "Dein Geburtstag *",
        day__kid: "Geburtstag / Geburtstermin *",
        month: "-monat *",
        year: "-jahr *",
        error_invalid: "Ungültiges Datum. Gib bitte Tag, Monat und Jahr (vierstellig) an.",
        error_person_too_young: "Mindestalter: 16 Jahre",
        error_person_too_old: "Höchstalter: 100 Jahre",
        error_kid_too_young: "Geburtstermin liegt zu weit in der Zukunft",
        error_kid_too_old: "Höchstalter: 18 Jahre",
      },
      profile: {
        invalid_heading: "Bitte vervollständige Dein Profil",
      }
    },
    participation: {
      close: "später ausfüllen",
      btn_validate: "Eingabe überprüfen",
      btn_save_and_continue: "speichern & teilnehmen!",
      hint_missing_data: "Angaben unvollständig! Bitte überprüfe Deine Angaben.",
      missing_data: {
        title: "Du hast es fast geschafft!",
        header: "Bitte schließe Deine Registrierung jetzt ab, um an <b><i>{{ title }}</i></b> teilzunehmen.",
      },
      missing_terms: {
        /* title: "Bitte zustimmen.", TODO needs to discern between version=1 and version>1
        header: "Bitte stimme folgenden Teilnahmebedingungen zu:", */
        title: "Teilnahmebedingungen",
        header: "Bitte stimme den aktuellen Bedingungen zu:",
        btn_form_invalid: "Bitte zustimmen",
        btn_show_full_text: "Details anzeigen.",
        btn_hide_full_text: "Details ausblenden."
      },
      missing_access_code: {
        title: "Zugangscode notwendig",
        header: "Gib bitte Deinen Code ein:",
        fld_code_label: "Dein Code:",
        "err_invalid-code": "Der von Dir angegebene Code '{{code}}' ist nicht gültig!",
        "err_codes-depleted": "Alle Codes wurden bereits aufgebraucht!",
        "err_code-already-claimed": "Der Code '{{code}}' wurde bereits verwendet!"
      },
      missing_custom_fields: {
        title: "Ihre Meinung interessiert uns.",
        header: "Bitte beantworte folgende Umfrage:",
      },
      success: {
        "title__sweepstake/standard": "Teilnahme erfolgreich!",
        "title__coupon/free": "erfolgreich aktiviert!",
        "title__coupon/absolute": "Gutschein aktiviert!",
        "title__coupon/offer": "Gutschein aktiviert!",
        "title__coupon/m_for_n": "Gutschein aktiviert!",
        "title__coupon/percent": "Gutschein aktiviert!",
        "title__tip/standard": "Gutschein aktiviert!",
        "title__tip/offer": "Gutschein aktiviert!",
        heading_what_next: "Und jetzt?",
        heading_or: "Oder",
        current_points_text: "Dein Punktestand:",
        current_points_points: "{{points, NUMBER}}",
        points_gained: "+{{points, NUMBER}} Punkte",
        points_spent: "-{{points, NUMBER}} Punkte",
        chance_to_win_text: "Deine Gewinnchance:",
        chance_to_win_chance: "{{your, NUMBER}} / {{total, NUMBER}}",
        redirect_hint: "Wir leiten dich in Kürze zum Sponsor",
        redirect_go_to_merchant: "Zum Sponsor!",
        redirect_abort: "Weiterleitung abbrechen",
        redirect_hint_free: "Besuche die Webseite des Sponsors, um deinen Gutschein einzulösen.",
        default_code_hint: "Kopiere deinen Gutscheincode und löse diesen beim Sponsor ein:",
        default_code_hint_free: "FREE TODO: Kopiere deinen Gutscheincode und löse diesen beim Sponsor ein:",
        coupon_code_heading: "Dein Gutscheincode",
        coupon_no_code_heading: "Stichwort",
        coupon_no_code_fake_code: "LetsFamily.de",
        coupon_online_code_hint:"Kopiere den Code und löse deinen Gutschein im Online-Shop ein",
        coupon_free_online_code_hint:"Kopiere den Code und löse dein Geschenk im Online-Shop ein",
        coupon_online_redeem_code_cta: "Code kopieren & beim Sponsor einlösen",
        coupon_free_online_redeem_code_cta: "Code kopieren & beim Sponsor einlösen",
        coupon_show_qrcode:"QR-Code anzeigen",
        coupon_show_barcode:"Barcode anzeigen",
        coupon_show_map_heading: "Löse deinen Gutschein im Geschäft des Sponsors ein",
        coupon_free_show_map_heading: "Löse dein Geschenk im Geschäft des Sponsors ein. Das Geschenk wird nicht per Post zugestellt",
        go_to_map_cta: "Zur Karte",
        coupon_online_nocode_hint:"Löse deinen Gutschein im Online-Shop ein",
        coupon_free_online_nocode_hint:"Hol dir dein Geschenk im Online-Shop",
        coupon_online_nocode_cta: "Beim Sponsor einlösen",
        coupon_free_online_nocode_cta: "Beim Sponsor einlösen",
        share_hint: "Mit Freunden teilen",
        share_for_points_cta: "Auf Facebook teilen und 1.000 Punkte erhalten",
        back_to_site_hint: "Zurück nach LetsFamily.de",
        back_to_site_cta: "An anderen Aktionen teilnehmen",
        btn_close: "schliessen",
        sweep_participate_again_hint: "Erhöhe Deine Gewinnchance und nimm nochmals teil für  {{points, NUMBER}} Punkte.",
        sweep_participate_again_cta: "Nochmals Teilnehmen für {{points, NUMBER}} Punkte",
        show_merchant_instructions_go_to_campaign: "Zurück zur Aktion",
        coupon_free_landing_page_heading: "Besuche die Webseite des Sponsors, um dein Geschenk einzulösen",
        coupon_free_go_to_merchant: "Geschenk einlösen",
      },
      error: {
        'title__ALREADY-PARTICIPATED': "Bereits teilgenommen!",
        'title__USER-NOT-ENOUGH-POINTS': "Nicht genug Punkte!",
        'title__USER-INACTIVE': "Moment mal!",
        'title__CAMPAIGN-OFFLINE': "Moment mal!",
        'title__CAMPAIGN-PENDING': "Moment mal!",
        'title__CAMPAIGN-EXPIRED': "Moment mal!",
        'title__UNKNOWN-ERROR-EMPTY-RESULT': "Oops da stimmt was nicht!",
        header: "Teilnahme nicht möglich!",
        'err__ALREADY-PARTICIPATED': "Du hast bereits an dieser Aktion teilgenommen. Deine Teilnahmeinformationen findest du, nachdem du dieses Popup geschlossen hast",
        'err__USER-NOT-ENOUGH-POINTS': "Du hast nicht genug Punkte, um an dieser Aktion teilzunehmen. Nimm an anderen Aktionen teil, um wieder mehr Punkte zu bekommen!",
        'err__USER-INACTIVE': "Du hast deinen Account deaktiviert. Somit ist leider keine Teilnahme möglich",
        'err__CAMPAIGN-OFFLINE': "Diese Aktion ist offline.",
        'err__CAMPAIGN-PENDING': "Diese Aktion hat noch nicht begonnen. Hab noch ein wenig Geduld!",
        'err__CAMPAIGN-EXPIRED': "Diese Aktion ist schon abgelaufen.",
        'cta__USER-NOT-ENOUGH-POINTS': "An anderen Aktionen teilnehmen, um Punkte zu sammeln",
        'cta__ALREADY-PARTICIPATED': "Zurück zur Aktion",
        'err__UNKOWN-ERROR-EMPTY-RESULT': "Da ist etwas schiefgelaufen. Bitte probiere es etwas später noch einmal."
      },
      telephoneVerify: {
        title_request: "Zwei-Faktor-Authentifizierung (2FA) erforderlich",
        title_confirm: "Bitte SMS-TAN eingeben.",
        header: "Du erhältst eine SMS-TAN zur Verifizierung.",
        please_confirm_tel: "Bitte überprüfe Deine Mobiltelefonnummer, damit Du die SMS-TAN auch sicher empfangen kannst.",
        please_correct_tel: "Bitte gib eine gültige Mobiltelefonnummer ein.",
        code_sent: "Wir haben Dir eine SMS mit Deiner TAN am {{created, DATETIME}} an {{tel}} geschickt.",
        fld_code: "Bitte gib die 5-stelligen SMS-TAN hier ein:",
        invalid_code: "Ungültige SMS-TAN!",
        btn_store_code: "SMS-TAN speichern",
        btn_request_code: "SMS-TAN anfordern",
        btn_fix_tel: "Telefonnummer aktualisieren",
        send_code_error: "SMS-TAN konnte nicht verschickt werden: {{error}}",
        warn_nonmobile: "Deine angegebene Telefonnummer ({{tel}}) schaut nicht nach einer Mobiltelefonnummer aus."
      }
    },
    map: {
      tbl_head_label: "Marker",
      tbl_head_title: "Titel",
      tbl_head_merchant: "Anbieter",
      tbl_head_type: "Kampagnentyp",
      tbl_head_phase: "Phase",
      tbl_head_link: "Link",
      info_party: "Jetzt teilnehmen",
      benefit_abs_disc: "Gutscheinwert",
      benefit_rel_disc: "Rabatt",
      benefit_free: "Gratis statt",
      c_absolute: "Wertgutschein",
      c_percent: "Rabattgutschein",
      c_offer: "Vergünstigung",
      c_free: "Gratis Voucher",
      phase_active: "Aktiv",
      phase_ended: "Abgelaufen",
      phase_pending: "Noch nicht aktiv",
      view: {
        tbl_head_name: "Name",
        tbl_head_street: "Adresse",
        tbl_head_distance: "Entfernung [m]",
        tbl_head_city: "Stadt",
        tbl_head_latlng: "GPS"
      }
    }
  }
}
